import { Card, CardBody, Col } from "reactstrap";
import { Href, MollyBoake, ScrollableList } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { SCROLLABLE_DATA } from "../../../../Data/UiKit/Lists";
import { H6, Image, LI, P, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { DynamicScrollableLists } from "./DynamicScrollableLists";

const ScrollableLists = () => {
  return (
    <Col xxl="4">
      <Card>
        <CommonCardHeader title={ScrollableList} span={SCROLLABLE_DATA} />
        <CardBody>
          <UL className="main-lists-content scrollbar-wrapper theme-scrollbar">
            <LI tag="a" className="list-group-item-action active list-hover-primary" href={Href}>
              <div className="list-wrapper gap-0">
                <Image className="list-img mx-2" src={dynamicImage("user/9.jpg")} alt="profile" />
                <div className="list-content">
                  <H6>{MollyBoake}</H6>
                  <P>MollyBoake@rhyta.com</P>
                  <small>5 days ago</small>
                </div>
              </div>
            </LI>
            <DynamicScrollableLists />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ScrollableLists;
